@if (member) {
<div class="user-entry">
  <div class="user-info">
    <div class="display-name">{{ member.displayName }}</div>
    <div class="email">{{ member.userPrincipalName }}</div>
  </div>
</div>
@if (!isReadOnly) {
<div class="member-options">
  <mat-form-field class="iconf-select" appearance="outline">
    <mat-select [(ngModel)]="member.userProjectRoleTitle" (selectionChange)="updated.emit()" placeholder="select role">
      @for (role of roleTitles; track role) {
      <mat-option [value]="role">{{ role }}</mat-option>
      }
    </mat-select>
  </mat-form-field>
  <button (click)="onDelete()" class="iconf-btn-blank minw50 iconf-btn-custom">
    <mat-icon>close</mat-icon>
  </button>
</div>
} }
